import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import * as requestToApi from "./PromotionCRUD";
import { promotionSlice } from "./PromotionSlice";

const { actions } = promotionSlice;

export const getPromotionList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return requestToApi
    .fetchPromotionList(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.promotionListFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchPromotionList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};
